import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-tareas",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./tareas.component.html"
})
export class TareasComponent {}
